const {ppeFields, SIZE_LABELS} = require('./requestPpe');
const clone = value => JSON.parse(JSON.stringify(value));
let sequence = 0;
function newKey() { return `ppe-${Date.now()}-${++sequence}`; }
function personKey(row) { return row.employee_id ? `employee-${row.employee_id}` : row.key; }
function itemKey(item) { return String(item._tempId || item.id || item.catalog_item_id); }
function guessKind(item) {
    const name = (item.item_name || item.name || '').toLowerCase();
    if (/каск|шапк|кепк|головн/.test(name)) return 'headwear';
    if (/перчат|рукавиц/.test(name)) return 'gloves';
    if (/ботин|сапог|обув|полубот|тапоч/.test(name)) return 'shoes';
    if (/куртк|жилет/.test(name)) return 'jacket';
    if (/брюк|штан|полукомбинезон/.test(name)) return 'trousers';
    if (/костюм|комбинезон/.test(name)) return 'suit';
    if (/комплект/.test(name)) return 'kit';
    return 'none';
}
function emptyPpe(item) { return {version: 1, kind: guessKind(item), recipients: [], stock: []}; }
function rosterFromItems(items, existing = []) {
    const result = clone(existing);
    for (const item of items) for (const row of item.ppe_data && item.ppe_data.recipients || []) {
        let person = result.find(value => personKey(value) === personKey(row));
        if (!person) { person = clone(row); result.push(person); }
        person.sizes = person.sizes || {}; person.baseline = person.baseline || {}; person.dirty_fields = person.dirty_fields || [];
        for (const field of Object.keys(SIZE_LABELS)) if (!(field in person.sizes) && field in (row.sizes || {})) {
            person.sizes[field] = row.sizes[field]; person.baseline[field] = (row.baseline || {})[field] || null;
            if ((row.dirty_fields || []).includes(field)) person.dirty_fields.push(field);
        }
    }
    return result;
}
function personForKind(person, kind) {
    const row = clone(person);
    row.quantity = 1;
    row.sizes = {}; row.baseline = {};
    for (const field of ppeFields(kind)) {
        row.sizes[field] = person.sizes && person.sizes[field] || '';
        row.baseline[field] = person.baseline && person.baseline[field] || null;
    }
    row.dirty_fields = (person.dirty_fields || []).filter(field => ppeFields(kind).includes(field));
    return row;
}
function plannedQuantity(data) {
    return Math.round([...(data.recipients || []), ...(data.stock || [])].reduce((sum, row) => sum + Number(row.quantity || 1), 0) * 1000) / 1000;
}
function assignPeople(item, people, enabled) {
    const next = clone(item), data = next.ppe_data || emptyPpe(item);
    for (const person of people) {
        const index = data.recipients.findIndex(row => personKey(row) === personKey(person));
        if (enabled && index < 0) data.recipients.push(personForKind(person, data.kind));
        if (!enabled && index >= 0) data.recipients.splice(index, 1);
    }
    next.ppe_data = data; next.quantity = plannedQuantity(data);
    return next;
}
function applyRoster(items, before, after) {
    return items.map(item => {
        if (!item.ppe_data) return item;
        const next = clone(item), data = next.ppe_data;
        const count = data.recipients.length;
        data.recipients = data.recipients.map(row => {
            const old = before.find(person => personKey(person) === personKey(row));
            const replacement = old && after.find(person => person.key === old.key && personKey(person) !== personKey(old));
            return replacement ? {...personForKind(replacement, data.kind), quantity: row.quantity || 1} : row;
        });
        data.recipients = data.recipients.filter(row => after.some(person => personKey(person) === personKey(row)));
        for (const row of data.recipients) {
            const person = after.find(value => personKey(value) === personKey(row));
            const old = before.find(value => personKey(value) === personKey(row));
            if (!old) continue;
            if (person.name !== old.name) row.name = person.name;
            if (person.notes !== old.notes) row.notes = person.notes;
            for (const field of ppeFields(data.kind)) {
                // Unchanged and conflicting snapshots are preserved until an explicit edit.
                if ((person.sizes[field] || '') === (old.sizes[field] || '') &&
                    (person.dirty_fields || []).includes(field) === (old.dirty_fields || []).includes(field)) continue;
                const edited = (person.dirty_fields || []).includes(field);
                // Explicit prefill fills empty snapshots without scheduling a write back to the card.
                if (!edited && (row.sizes[field] || (row.dirty_fields || []).includes(field))) continue;
                row.sizes[field] = person.sizes[field] || '';
                if (!(row.dirty_fields || []).includes(field)) row.baseline[field] = person.baseline[field] || null;
                if (edited) row.dirty_fields = Array.from(new Set([...(row.dirty_fields || []), field]));
                data.sync_results = (data.sync_results || []).filter(result => result.key !== row.key || result.field !== field);
            }
        }
        if (data.recipients.length !== count) next.quantity = plannedQuantity(data);
        return next;
    });
}
function changeKind(item, kind, people) {
    const next = clone(item), data = next.ppe_data || emptyPpe(item);
    data.kind = kind;
    for (const row of [...data.recipients, ...(data.stock || [])]) {
        const person = row.employee_id !== undefined && people.find(value => personKey(value) === personKey(row));
        for (const field of Object.keys(row.sizes || {})) if (!ppeFields(kind).includes(field)) delete row.sizes[field];
        if (person) for (const field of ppeFields(kind)) if (!(field in row.sizes)) {
            row.sizes[field] = person.sizes[field] || ''; row.baseline[field] = person.baseline[field] || null;
        }
        if (row.dirty_fields) row.dirty_fields = row.dirty_fields.filter(field => ppeFields(kind).includes(field));
    }
    data.sync_results = (data.sync_results || []).filter(result => ppeFields(kind).includes(result.field));
    next.ppe_data = data;
    return next;
}
module.exports = {newKey, personKey, itemKey, guessKind, emptyPpe, rosterFromItems, plannedQuantity, assignPeople, applyRoster, changeKind};
